import React from "react";

interface SubSectionTitleProps {
  children: React.ReactNode;
}

/**
 * Component for subsection titles in forms
 */
const SubSectionTitle: React.FC<SubSectionTitleProps> = ({ children }) => {
  return (
    <h3 className="text-[18px] font-bold uppercase tracking-[0.05em] text-[#323232] mb-4">
      {children}
    </h3>
  );
};

export default SubSectionTitle;
